import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/axios'
import tool from './utils/tool'
import util from './utils/util'
import MrConfirm from '@/plugins/confirm/index'
import MrToast from '@/plugins/toast/index'
import Cookie from 'js-cookie'

import weixinlogin from '@/libs/weixinlogin'
import NVC_Opt from '@/libs/NVC_Opt'
import aliPuzzle from '@/libs/ali'
import Login from '@/components/login.vue'

Vue.config.productionTip = false

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/common.scss'
import ElementUI from 'element-ui'
Vue.use( ElementUI )

Vue.use(NVC_Opt)
Vue.use(aliPuzzle)
Vue.use(weixinlogin)
Vue.component( 'login', Login )

Vue.mixin({
    mounted(){
        if( Cookie.get("loginId") && this.$root._uid == this._uid ){
            store.state.login.loginId = Cookie.get("loginId")
            store.state.login.authorization = Cookie.get("authorization")
        }
    }
})

axios.defaults.timeout = 15000
axios.defaults.baseURL = process.env.MODE == 'pro' ? 'https://gate.laozicloud.com' : 'https://mop.laozicloud.net'
Vue.prototype.axios = axios
Vue.prototype.$bus = new Vue()
Vue.prototype.$tool = tool
Vue.prototype.$util = util

Vue.use(MrConfirm)
Vue.use(MrToast)

var app = new Vue({
    data:{
        //登录弹窗
        loginVisible:false,
        //注册协议弹窗
        agreeVisible:false,
        //注册弹窗
        registVisible:false,
        //忘记密码弹窗
        pwdVisible:false,
        //绑定手机号弹窗
        bindPhoneVisible:false,
    },
    router,
    //@ts-ignore
    store,
    render: h => h(App)
}).$mount('#app')

export default app